export const dashboardSideNavLinks = [
  {
    title: 'My Documents',
    url: '/dashboard/documents',
    icon: 'ant-design:folder-open-outlined'
  },
  {
    title: 'Trash',
    url: '/dashboard/trash',
    icon: 'ant-design:delete-outlined'
  },
  {
    title: 'My Account',
    url: '/dashboard/account',
    icon: 'ant-design:user-outlined'
  }
];